import React from 'react'
import { Switch, SwitchProps } from '@mui/material'
import { styled } from '@mui/material/styles'
import { white } from '../../../assets/colors'

export type ToggleSwitchProps = SwitchProps & {
    onColor?: string,
    offColor?: string,
    backgroundOpacity?: number,
    thumbColor?: string
}

const ToggleSwitch = styled(React.forwardRef<HTMLButtonElement, ToggleSwitchProps>(({ onColor, offColor, backgroundOpacity, thumbColor, ...props }, ref) => (
    <Switch ref={ref} disableRipple {...props} />
)))(({ theme, onColor, offColor, backgroundOpacity, thumbColor }) => ({
    width: 38,
    height: 20,
    padding: 0,
    borderRadius: 10,
    overflow: 'hidden',
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2.5,
        color: '#fff',

        '&.Mui-disabled .MuiSwitch-thumb': {
            color: thumbColor || (theme.palette.mode === 'light'
                ? theme.palette.grey[300]
                : theme.palette.grey[600])
        },

        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.3
        },

        '&.Mui-checked': {
            transform: 'translateX(18px)',

            '& + .MuiSwitch-track': {
                backgroundColor: onColor || '#2962fd',
                border: 0,
                opacity: backgroundOpacity || 1
            },
            '&.Mui-disabled': {
                opacity: 0.7
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5
            },
            '& .MuiSwitch-thumb': {
                color: white
            }
        }
    },
    '& .MuiSwitch-track': {
        backgroundColor: offColor || (theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D'),
        opacity: backgroundOpacity || 1,
        border: 0,
        transition: theme.transitions.create(['background-color'], {
            duration: 300
        })
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 15,
        height: 15,
        color: thumbColor
    }
}))

export default ToggleSwitch